import { Row } from "react-bootstrap";
import NewRefer from "./NewRefer";
import ReferList from "./ReferList";
import { useState } from "react";

export default function WorkItemRefer({ workItem, doRefer, onReferDone: externalReferDone }) {
    const [refreshList, setRefreshList] = useState(false);
    const onReferDone = (data) => {
        setRefreshList(prev => !prev);
        externalReferDone?.(data);
    }
    return (
        <Row className="rowBorder mt-3">
            <div className="rowTitle mb-3">ارجاعات</div>
            <NewRefer workItem={workItem} onReferDone={onReferDone} doRefer={doRefer} />
            <ReferList id={workItem.ID} type={workItem.Type} refresh={refreshList} />
        </Row>
    )
}